/* ============================================================
   MAMAF behaviour: exact hero height, sticky nav colour swap,
   live Istanbul clock.
   ============================================================ */
(function () {
  /* 1. Expose the real header-group height so the hero can be
        calc(100vh - header) === exactly one screen incl. the nav. */
  function setHeaderHeightVar() {
    var main = document.getElementById('MainContent');
    if (main) {
      document.documentElement.style.setProperty(
        '--mf-header-h',
        main.offsetTop + 'px'
      );
    }
  }

  /* 2. Sticky nav: black at top, white once scrolled past the hero. */
  function initStickyColour() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    function onScroll() {
      if (window.scrollY > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* 4. Live Istanbul date/time, top-left of the announcement bar.
        It used to sit in the header row and collided with the nav links at
        every desktop width; the announcement bar only holds one centred
        line, so the far-left corner there is always free. */
  function initClock() {
    var mount =
      document.querySelector('.utility-bar') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('.header');
    if (!mount) return;
    var el = document.createElement('div');
    el.className = 'mf-clock';
    mount.appendChild(el);

    function tick() {
      var s = new Date().toLocaleString('en-GB', {
        timeZone: 'Europe/Istanbul',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
      // e.g. "30/06/2026, 02:05 pm" -> "30/06/2026 02:05pm IST"
      s = s.replace(',', '').replace(' pm', 'pm').replace(' am', 'am');
      el.textContent = s + ' IST';
    }
    tick();
    setInterval(tick, 1000);
  }

  /* 5. Hero video: force muted inline autoplay (iOS / low-power mode can
        ignore the attributes), retry on first touch if the browser blocked it. */
  function initHeroVideo() {
    var videos = document.querySelectorAll('.hero-drop__media-el--video video');
    if (!videos.length) return;
    videos.forEach(function (v) {
      v.muted = true;
      v.defaultMuted = true;
      v.loop = true;
      v.autoplay = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.removeAttribute('controls');
      var tryPlay = function () {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      };
      tryPlay();
      ['touchstart', 'click', 'scroll'].forEach(function (evt) {
        window.addEventListener(evt, tryPlay, { once: true, passive: true });
      });
    });
  }

  function init() {
    setHeaderHeightVar();
    initStickyColour();
    initClock();
    initHeroVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('resize', setHeaderHeightVar, { passive: true });
})();
